import React from "react";
import { Typography, Link } from "@mui/material";

const MyAchievementsItemTitle = props => {
  const { id, courseTitle, link } = props;

  if (link) {
    return (
      <Typography key={`title-${id}`}>
        <Link href={link} target="_blank" variant="body2">
          {courseTitle}
        </Link>
      </Typography>
    );
  } else {
    return <Typography>{courseTitle}</Typography>;
  }
};

export default MyAchievementsItemTitle;
